<template>
  <SiteIndex v-if="isIndex" :white-list="[]" :model="model" />
  <site-shop-cart v-else-if="isShopCart" :model="model" />
</template>

<script>
import SiteIndex from "~/site/components/siteIndex"
import SiteCore, {
  checkLogin,
  getSiteBuilderDataByService,
  getIpInfo,
  checkVisitStatus,
  getSiteHead, checkDialogStatus
} from '~/site/core'
import { useAssets } from "~/hooks/useAssets"
import eventTracker from "~/mixins/eventTracker"
import tools from '~/utils'
import { removeDefaultManifest } from "~/utils/dom"
import langConfigMixins from "~/mixins/langConfigMixins"
import SiteShopCart from "~/site/components/shopCartPage/index.vue"
import { PageNameEnum } from "~/enums/pageEnum"
import { EventCodeEnums } from "~/enums/siteEnum"

export default {
  name: "SiteIndexPage",
  components: {
    SiteShopCart,
    SiteIndex
  },
  mixins: [langConfigMixins, eventTracker],
  layout: 'defaultLayout',
  async asyncData(options) {
    const isProd = true
    return await getSiteBuilderDataByService({ ...options, isProd })
  },
  data() {
    return {
      model: null,
      lang: {},
      pLang: '',
      native: null,
      mid: '',
      web: {},
      pageId: '',
      pid: '',
      domain: '',
      siteBuildId: '',
      langList: [],
      pageList: [],
      siteInfo: {
        default_language: '',
        published_conf: {}
      },
      baseInfo: {},
      languages: [],
      pwa: {}
    }
  },
  head() {
    return getSiteHead(this)
  },
  computed: {
    isIndex() {
      const { native, model } = this
      return (!native || [PageNameEnum.VIP_CLUB].includes(native)) && model
    },
    isShopCart() {
      const { native, model } = this
      return (native === PageNameEnum.SHOP_CART) && model
    }
  },
  beforeDestroy() {
    //
  },
  async mounted() {
    // 应用支持的语言列表
    const { setSiteLangList } = useAssets(this)
    setSiteLangList(this.langList)
    await this.setNewUrl()
    await removeDefaultManifest()
  },
  methods: {
    checkEntityForRedirect() {
      const redirectData = this.siteInfo.redirect
      const ipInfo = this.$store.state.user.ipInfo
      const country = ipInfo.country
      if (!redirectData) return
      const origin = window.origin
      const redirect = redirectData[country] || []
      if (!redirect.length) {
        const defaultUrl = redirectData?.default?.[0]?.domain
        const defaultData = redirectData?.default || []
        const isFind = defaultData.find(item => origin.includes(item.domain))
        if (!isFind && defaultUrl) window.open('https://' + defaultUrl, '_self')
      } else {
        const isFind = redirect.find(item => origin.includes(item.domain))
        const hasDefault = redirectData?.default?.length
        const defaultUrl = redirect[0]?.domain
        if (!isFind && hasDefault) window.open('https://' + defaultUrl, '_self')
      }
    },
    reporting() {
      this.eventTracker(EventCodeEnums.STORE_VISITED)
    },
    async setNewUrl() {
      if (!this.pLang) {
        const query = this.$route.query
        const sysLang = tools.getSysLanguage()
        const langArr = this.langList.map(item => item.code)
        const curLang = langArr.includes(sysLang) ? sysLang : this.siteInfo.default_language
        this.pLang = curLang
        const fullPath = `/${this.pageId}${this.pageId ? '/' : ''}${curLang}`
        await this.$router.push({
          path: fullPath,
          query
        })
      } else {
        await this.init()
      }
      this.$cookies.set('lang', this.pLang)
      tools.setFavicon(this.web.site.seoSetting.favicon)
    },
    async getCurrencies() {
      const res = await this.$api.common.getCurrencies()
      const map = {}
      res.data.forEach((c) => {
        map[c.id] = c
      })
      this.$store.commit('project/SET_CURRENCYINFO', {
        currency: res.data,
        currencieMap: map,
      })
    },
    async init() {
      await checkLogin(this)
      await getIpInfo(this)
      await checkVisitStatus(this)
      await this.getCurrencies()
      this.reporting()
      this.checkEntityForRedirect()
      const lang = this.pLang || this.siteInfo.default_language
      const langIdData = await this.getLangConfig(lang, this.siteInfo.default_language, this.pid)
      this.model = new SiteCore({
        editMode: false,
        siteInfo: this.siteInfo.published_conf,
        baseInfo: this.baseInfo,
        languages: this.languages,
        langList: this.langList,
        lang,
        langIdData,
        pageList: this.pageList,
        isProd: true
      })
      tools.setPageTitle(this.web.site.seoSetting, langIdData)
      this.$store.commit('locale/SET_LANG', this.pLang || this.siteInfo.default_language)
      this.$store.commit('locale/SET_LANG_DATA', langIdData)
      await checkDialogStatus(this)
    }
  }
}
</script>
